export default __webpack_public_path__ + "static/media/no-image.f28d6b9f.png";